/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import { closelightbox } from "../../util/Functions";
import { Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";
import ReactJson from "react-json-view";
import "moment/locale/es";

const ConfigFactor = (props) => {
  const [config, setConfig] = useState({});
  const [title, setTitle] = useState("");
  const [root, setRoot] = useState("data");
  useEffect(() => {
    init();
  }, []);

  const init = () => {
    if (props.config) {
      setConfig(JSON.parse(JSON.stringify(props.config)));
    }
    if (props.hasOwnProperty("title")) {
      setTitle(props.title);
    }
    if (props.hasOwnProperty("root")) {
      setRoot(props.root);
    }
  };

  return (
    <Dialog open={true} fullWidth>
      <ModalStyle property={String(false)}>
        <DialogTitle>
          Configuración de cliente: {title}
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>        
        <DialogContent sx={{padding: "20px 20px 0px !important"}}>
          {config && (
            <ReactJson
              src={config}
              name={root}
              collapsed={true}
              displayDataTypes={false}
              style={{ maxHeight: "600px", overflowY: "scroll", marginBottom: "30px" }}
            />
          )}
        </DialogContent>
        <DialogActions> 
          <Button variant="contained" onClick={closelightbox} >Aceptar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};

export default ConfigFactor;
